import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { API_GATEWAY_URL, DEFAULT_HEADERS, GOOGLE_TOKEN_KEY } from '../constants';

const Unsubscribe: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState<string>('Processing your unsubscribe request...');

  useEffect(() => {
    const email = searchParams.get('email');
    
    if (!email) {
      setStatus('error');
      setMessage('No email provided. Please check the link and try again.');
      return;
    }

    const unsubscribeUser = async () => {
      try {
        await axios.delete(`${API_GATEWAY_URL}/subscriptions/${encodeURIComponent(email)}`, {
          headers: DEFAULT_HEADERS
        });
        // Remove Google token from local storage
        localStorage.removeItem(GOOGLE_TOKEN_KEY);
        setStatus('success');
        setMessage('You have been successfully unsubscribed from Arabic Word of the Day notifications.');
      } catch (error) {
        console.error('Unsubscribe error:', error);
        setStatus('error');
        setMessage('Failed to unsubscribe. Please try again later or contact support.');
      }
    };

    unsubscribeUser();
  }, [searchParams]);

  return (
    <div className="App">
      <header className="App-header">
        <h1>Arabic Word of the Day</h1>
      </header>
      
      <main className="App-main">
        <div className="unsubscribe-container">
          <h2>Unsubscribe from Arabic Word of the Day</h2>
          <div className={`status-message ${status}`}>
            <p>{message}</p>
            {status !== 'loading' && (
              <button className="home-link" onClick={() => navigate('/')}>Return to Home</button>
            )}
          </div>
        </div>
      </main>
      
      <footer className="App-footer">
        <p>&copy; {new Date().getFullYear()} Arabic Word of the Day</p>
      </footer>
    </div>
  );
};

export default Unsubscribe;